import '@/stylesheet/main.css'
import '@/stylesheet/themes.scss'
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css"
import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/round.css';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createApp } from 'vue'
import router from './router'
import $ from 'jquery';
import { createPinia } from "pinia";
import icons from "@/config/icons";
import App from './App.vue'

icons();
window.$ = $
const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())
app.use(router)
app.mount('#app')
